import BaseForm from './baseForm';
import * as Choices from 'choices.js';

export default class Newsletter extends BaseForm {
  constructor() {
    super('newsletter-form');
  }

  init() {
    super.init('newsletter-form');
    let select = document.querySelector('#fields-salutation');

    if (select) {
      new Choices(select, {
        searchEnabled: false,
        itemSelectText: '',
        labelId: 'salutation-label',
      });

      const salutationField = document.querySelector('[aria-labelledby="salutation-label"]');
      salutationField.setAttribute('aria-describedby', 'salutation-error');
      salutationField.setAttribute('aria-required', 'true');
    }

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('email')) {
      document.querySelector('[name="fields[email]"]').value = urlParams.get('email');
    }
  }

  getFormValidationConstraints() {
    return {
      ...this.notEmptyConstraint('fields[firstName]'),
      ...this.notEmptyConstraint('fields[lastName]'),
      ...this.notEmptyConstraint('fields[salutation]'),
      ...this.notEmptyConstraint('fields[personTitle]'),
      ...this.notEmptyConstraint('fields[organization]'),
      ...this.notEmptyConstraint('fields[industry]'),
      ...this.emailConstraint('fields[email]')
    };
  }
}
